// extracted by mini-css-extract-plugin
module.exports = {"label":"InputLabel_label__4Yv_Q","labelContent":"InputLabel_labelContent__AueGA","labelIcon":"InputLabel_labelIcon__DABQ_","labelName":"InputLabel_labelName__EBI_W"};